<template>
  <div class="toggle-container" @click="toggle">
	<span :class="{'btn-close': isOpen }">{{ isOpen ? '收起' : '展开' }}</span>
    <i :class="isOpen ? 'el-icon-arrow-up btn-close' : 'el-icon-arrow-down'"></i>
  </div>
</template>

<script>
export default {
  model: {
	prop: 'isOpen',
	event: 'change'
  },
  props: {
	isOpen: {
		type: Boolean,
		default: false
	}
  },
  data () {
	return {}
  },
  mounted () {

  },
  methods: {
	// 展开收起切换
	toggle() {
		this.$emit('change', !this.isOpen)
	}
  }
}
</script>

<style lang="scss" scoped>
.toggle-container {
	display: flex;
	height: 100%;
	min-width: 50px;
	padding-top: 17px;
	cursor: pointer;
	span {
	  font-size: 12px;
      color: #666;
	  margin-right: 5px;
	}
	i {
		margin-top: 3px;
		font-size: 12px;
	}
	.btn-close {
		color: #ff6600;
	}
}
</style>
